import { CSSProperties, ReactNode, useEffect, useRef } from 'react';
import { Marker, MarkerProps } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-rotatedmarker';

declare module 'leaflet' {
    interface Marker {
        setRotationAngle(angle: number): this;
        setRotationOrigin(origin: string): this;
    }
}

interface RotatedMarkerProps extends MarkerProps {
    rotationAngle?: number;
    rotationOrigin?: string;
    style?: CSSProperties;
}

export default function RotatedMarker({
    rotationAngle = 0,
    rotationOrigin = 'center',
    style,
    ...props
}: RotatedMarkerProps): ReactNode {
    const markerRef = useRef<L.Marker>(null);

    useEffect(() => {
        const marker = markerRef.current;
        if (!marker) {
            return;
        }
        if (typeof marker.setRotationAngle === 'function') {
            marker.setRotationAngle(rotationAngle);
        }
        if (typeof marker.setRotationOrigin === 'function') {
            marker.setRotationOrigin(rotationOrigin);
        }

        if (style && marker.getElement()) {
            const element = marker.getElement();
            if (element) {
                Object.assign(element.style, style);
            }
        }
    }, [rotationAngle, rotationOrigin, style]);

    return <Marker ref={markerRef} {...props} />;
}
